// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3AUZq","tab":"ProcedureTabs_tab__2ryxo"};